<template>
  <div>
    <h3 class="my-auto">
      <b-button @click.prevent="backtolist" variant="outline-primary">&lt; Return to list</b-button>
      <span v-if="tutorial_id > 0" class="ml-4">{{tutorial_heading}}</span>
      <span v-if="tutorial_id < 0" class="ml-4">Add Tutorial</span>
    </h3>
    <b-card no-body class="border-0 mx-0 px-0 py-10 pl-0 pr-0 col-12">
      <form autocomplete=off @submit.stop.prevent>
        <b-row>
          &nbsp;
        </b-row>
        <b-row>
          <b-form-group 
            label-cols="2"
            label="Heading"
            class="col-12"
            invalid-feedback="Tutorial heading cannot be blank"
          >
            <b-form-input  
              id="tutorial_heading" 
              :state="tutorial_heading_valid"
              class="form-control col-6"
              v-model="tutorial_heading"
              v-on:change="savefield('g_tutorials',tutorial_id,'tutorial_heading',tutorial_heading)" 
              autocomplete="off"
            >
            </b-form-input>
          </b-form-group>
          <div class="col-12">
            <b-form-group label="Description">
              <vue-editor 
                v-model="tutorial_description" 
                :editorToolbar="editortoolbar"
                @text-change="savefield('g_tutorials',tutorial_id,'tutorial_description',tutorial_description)"
              >
              </vue-editor>
            </b-form-group>
          </div>
          <b-form-group 
            label-cols="2"
            label="Vimeo link"
            class="col-12"
            invalid-feedback="Tutorial link cannot be blank"
          >
            <b-form-input  
              id="tutorial_link" 
              :state="tutorial_link_valid"
              class="form-control col-6"
              v-model="tutorial_link"
              v-on:change="savefield('g_tutorials',tutorial_id,'tutorial_link',tutorial_link)" 
              autocomplete="off"
            >
            </b-form-input>
          </b-form-group>
          <div class="form-group col-12 mt-4">
            <b-button 
              v-if="tutorial_id < 1" 
              @click.prevent="tutorial_create" 
              class="mt-10"
              variant="primary"
            >
              Save New Tutorial
            </b-button>
          </div>
        </b-row>
      </form>
    </b-card>
  </div>
</template>
<script>
import { VueEditor} from "vue2-editor";

var editortools = [
  [{ font: [] }],
  [{ header: [false, 1, 2, 3, 4, 5, 6] }],
  [{ size: ["small", false, "large", "huge"] }],
  ["bold", "italic", "underline", "strike"],
  [
    { align: "" },
    { align: "center" },
    { align: "right" },
    { align: "justify" }
  ],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ color: [] }, { background: [] }],
  ["link", "image", "video", "formula"],
//  ["image"],
//  [{ direction: "rtl" }],
//  ["clean"]
];

export default {
  components: {
    VueEditor,
  },
  name: 'Consultant',
  created() {
    this.tutorial_get();
  },
  data: function() {
    return {
      editortoolbar: editortools,
      tutorial_heading: '',
      tutorial_heading_valid: null,
      tutorial_link: '',
      tutorial_link_valid: null,
      tutorial_description: '',
      loading: true,
    }
  },
  computed: {
    tutorial_id: {
      get() {
        return this.$store.state.currenttutorial_id;
      }
    },
    emailinvalidfeedback() {
      if (this.email == '') { return "E-mail is invalid"; }
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.email) == false) {
        return "Incorrect e-mail format";
      }
      return "E-mail already exists";
    }
  },
  watch: {
    tutorial_id: function() {
      this.tutorial_get()
    }
  },
  methods: {
    checkform() {
      var formok = true;
      this.tutorial_heading_valid = true;
      if (this.tutorial_heading == '') { 
        this.tutorial_heading_valid = false; 
        formok = false;
      }
      this.tutorial_link_valid = true;
      if (this.tutorial_link == '') { 
        this.tutorial_link_valid = false; 
        formok = false;
      }
      return formok;
    },
    tutorial_create() {
      if (this.checkform()) {
        var tutorial = {
          tutorial_heading: this.tutorial_heading,
          tutorial_description: this.tutorial_description,
          tutorial_link: this.tutorial_link,
        }
        this.$store.dispatch('tutorial_create', { tutorial: tutorial })
        .then((resp) => {
          var tutorial_id = resp.data.id;
          this.$store.dispatch('tutorial_setcurrent',{ tutorial_id: tutorial_id })
          .then(() => {
            this.tutorial_get();
          });
        });
      }
    },
    savefield(tablename,id,fieldname,value) {
      if ( id > 0 ) {
        if (this.checkform()) {
          var record = {
            id: id,
            [fieldname]: value,
          }
          this.$store.dispatch('field_save', { tablename: tablename,record: record })
          .then(() => {
            this.$store.dispatch('tutorialchanged_set',{ tutorial_id: this.tutorial_id });
          });
        }
      }
    },
    tutorial_get() {
      this.tutorial_heading = '';
      this.tutorial_description = '';
      this.tutorial_link = '';
      this.labels = [];
      if (this.tutorial_id > 0) {
        this.$store.dispatch('tutorial_fetch', { tutorial_id: this.tutorial_id })
        .then((resp) => {
          this.tutorial_heading = resp.data.tutorial_heading;
          this.tutorial_description = resp.data.tutorial_description;
          this.tutorial_link = resp.data.tutorial_link;
          this.loading = false;
        });
      }
    },
    backtolist() {
      this.$store.dispatch('tutorial_setcurrent',{ tutorial_id: 0 })
    },
  }
}
</script>
